import { RouteConfig } from 'vue-router'

const Index = () => import('./purchase-jumprope-course/index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/promote-jumprope-increase-plan',
  name: 'activity_promote_jumprope_increase_plan',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '跳绳全能助力计划',
    ignoreLogin: true,
  },
}

export default [indexRoute]
